import type React from 'react';
import ListingSquare from 'app/shared/modules/listing-cards/ListingSquare';

import './ListingSquareList.scss';
import type { ListingDetails } from 'app/types/listingDetails.type';

interface ListingSquareListProps {
  listings: Array<ListingDetails>;
}

const ListingSquareList: React.FC<ListingSquareListProps> = ({ listings }) => {
  return (
    <div className="ListingSquareList">
      {listings.map((listing) => {
        return (
          <div className="ListingSquareList-item" key={listing.aliasEncoded || listing.maloneLotIdEncoded}>
            <ListingSquare listing={listing} />
          </div>
        );
      })}
    </div>
  );
};

export default ListingSquareList;
